const INITIAL_STATE = {
	aguardando: false,
	registro: {},
	modoTela: 'lista',
	lista: [],
	listaOperacao: [],
	listaTipo: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'OPERACAO_DESPESA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'OPERACAO_DESPESA_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

        case 'OPERACAO_DESPESA_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

		case 'OPERACAO_DESPESA_OPERACAO_SELECT_LISTADO':
            return {
				...state,
				listaOperacao: action.payload.data
			};

		case 'OPERACAO_DESPESA_TIPO_SELECT_LISTADO':
            return {
				...state,
				listaTipo: action.payload.data
			};

        default:
            return state;
    }
}
